import { JsonSchemaValidator } from "@common/json-schema-validator";
import { isNil, omitBy } from "lodash";
import {
  BrandEntityId,
  RoomId,
  RoomOwnerId,
  RoomPid,
  RoomTitle
} from "../../interface";
import {
  brandEntityId,
  roomDescription,
  roomId,
  roomIsDefault,
  roomIsLive,
  roomIsRecording,
  roomLiveAt,
  roomOwnerId,
  roomPid,
  roomStartAt,
  roomTitle
} from "../../schema";
import {
  RoomDescription,
  RoomIsDefault,
  RoomIsLive,
  RoomIsRecording,
  RoomLiveAt,
  RoomStartAt
} from "../../type";
import { BaseEntity } from "../base.entity";

export class RoomEntity extends BaseEntity<RoomEntityRaw> {
  private static validation = JsonSchemaValidator.compile(RoomEntity.schema());

  constructor(entity: RoomEntityRaw) {
    super(
      JsonSchemaValidator.assert(
        RoomEntity.validation,
        omitBy(entity, (_) => isNil(_))
      )
    );
  }

  static schema() {
    return {
      type: "object",
      required: [
        "id",
        "pid",
        "title",
        "ownerId",
        "isDefault",
        "isLive",
        "liveAt",
        "brandId",
        "isRecording"
      ],
      properties: {
        id: roomId,
        pid: roomPid,
        title: roomTitle,
        description: roomDescription,
        ownerId: roomOwnerId,
        isDefault: roomIsDefault,
        isLive: roomIsLive,
        liveAt: roomLiveAt,
        brandId: brandEntityId,
        isRecording: roomIsRecording,
        startAt: roomStartAt
      },
      additionalProperties: false
    };
  }
}

export interface RoomEntityRaw {
  id: RoomId;
  pid: RoomPid;
  title: RoomTitle;
  description?: RoomDescription;
  ownerId: RoomOwnerId;
  isDefault: RoomIsDefault;
  isLive: RoomIsLive;
  liveAt: RoomLiveAt;
  brandId: BrandEntityId;
  isRecording: RoomIsRecording;
  startAt?: RoomStartAt;
}

/**
 * @swagger
 * components:
 *   schemas:
 *     RoomEntity:
 *       type: object
 *       required:
 *         - id
 *         - pid
 *         - title
 *         - ownerId
 *         - isDefault
 *         - isLive
 *         - liveAt
 *         - brandId
 *         - isRecording
 *       properties:
 *         id:
 *           $ref: '#/components/schemas/RoomId'
 *         pid:
 *           $ref: '#/components/schemas/RoomPid'
 *         title:
 *           $ref: '#/components/schemas/RoomTitle'
 *         description:
 *           $ref: '#/components/schemas/RoomDescription'
 *         ownerId:
 *           $ref: '#/components/schemas/RoomOwnerId'
 *         isDefault:
 *           $ref: '#/components/schemas/RoomIsDefault'
 *         isLive:
 *           $ref: '#/components/schemas/RoomIsLive'
 *         liveAt:
 *           $ref: '#/components/schemas/RoomLiveAt'
 *         brandId:
 *           $ref: '#/components/schemas/BrandEntityId'
 *         isRecording:
 *           $ref: '#/components/schemas/RoomIsRecording'
 *         startAt:
 *           $ref: '#/components/schemas/RoomStartAt'
 */
